import { type FC, useContext, useState } from "react";

import { Section } from "@alpacahq/ui/old";

import { AppDetailsContext } from "./AppDetailsPage";

export const AppDetailsScreenshots: FC = () => {
  const {
    client: {
      extension: { screenshots },
    },
  } = useContext(AppDetailsContext);

  const [selectedScreenshot, setSelectedScreenshot] = useState<string>();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const closeOverlay = () => {
    setIsOverlayOpen(false);
    setSelectedScreenshot(undefined);
  };

  const openOverlay = (screenshot: string) => {
    setIsOverlayOpen(true);
    setSelectedScreenshot(screenshot);
  };

  if (!screenshots || screenshots.length === 0) {
    return null;
  }

  return (
    <Section title="Screenshots">
      <div className="screenshot-list flex space-x-4 overflow-x-auto">
        {screenshots.map((screenshot, index) => (
          <img
            key={screenshot}
            src={screenshot}
            alt={`Screenshot ${index + 1}`}
            onClick={() => openOverlay(screenshot)}
            className="max-h-32 max-w-32 cursor-pointer rounded-md"
          />
        ))}
      </div>
      {isOverlayOpen && (
        <div
          className="fixed top-0 left-0 flex h-full w-full items-center justify-center bg-black/50"
          onClick={closeOverlay}
        >
          <img
            src={selectedScreenshot}
            alt="Selected screenshot"
            className="max-h-90 max-w-90"
          />
        </div>
      )}
    </Section>
  );
};
